export const START = 'START';
export const CHECKING = 'CHECKING';
export const CHECKED = 'CHECKED';
